export default __webpack_public_path__ + "static/media/300_it.dffc4d64.xls";